/*
  Accessibility behaviour fixes (WCAG 2.1 AA).
  Hand-authored (not built by gulp). Loaded from snippets/script-tags.liquid.
*/
(function () {
  'use strict';

  var body = document.body;

  /* 1. Links styled as buttons (href="#" role="button") must also respond to Space. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target;
    if (el && el.tagName === 'A' && el.getAttribute('role') === 'button' && !el.hasAttribute('is')) {
      e.preventDefault();
      el.click();
    }
  });

  /* 2. Accordions: keep aria-expanded in sync with the panel it controls. */
  function syncExpanded(toggle) {
    var id = toggle.getAttribute('aria-controls');
    var panel = id && document.getElementById(id);
    if (!panel) return;
    var open = panel.offsetHeight > 0 && getComputedStyle(panel).display !== 'none';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function syncAllAccordions() {
    document.querySelectorAll('.accordion__toggle[aria-controls]').forEach(syncExpanded);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.accordion__toggle[aria-controls]');
    if (t) setTimeout(function () { syncExpanded(t); }, 450);
  });

  /* 3. Image links that repeat the product title link next to them: remove the duplicate tab stop. */
  function hideDuplicateImageLinks(root) {
    (root || document).querySelectorAll('.sidecart__item-image').forEach(function (a) {
      a.setAttribute('tabindex', '-1');
      a.setAttribute('aria-hidden', 'true');
    });
  }

  /* 4. Looping sliders clone their slides: clones must not be focusable or read twice. */
  function hideSliderClones(root) {
    (root || document).querySelectorAll('.swiper-slide-duplicate').forEach(function (slide) {
      slide.setAttribute('aria-hidden', 'true');
      slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
  }

  /* 5. Side cart drawer: dialog semantics, focus in on open, focus back on close, Esc closes. */
  var cartDrawer = document.querySelector('.sidecart.sidecart__side');
  var lastFocus = null;
  if (cartDrawer) {
    cartDrawer.setAttribute('role', 'dialog');
    cartDrawer.setAttribute('aria-modal', 'true');
    var title = cartDrawer.querySelector('.cart-title');
    if (title) {
      if (!title.id) title.id = 'SidecartTitle';
      cartDrawer.setAttribute('aria-labelledby', title.id);
    }
  }
  function cartIsOpen() {
    return body.classList.contains('sidecart-enabled--open');
  }
  function focusables(container) {
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
    );
  }
  var wasOpen = false;
  function onBodyClassChange() {
    if (!cartDrawer) return;
    var open = cartIsOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      lastFocus = document.activeElement;
      cartDrawer.removeAttribute('aria-hidden');
      setTimeout(function () {
        var closeBtn = cartDrawer.querySelector('.sidecart__close-btn') || focusables(cartDrawer)[0];
        if (closeBtn) closeBtn.focus();
      }, 100);
    } else {
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }
  }
  if (cartDrawer && !cartIsOpen()) cartDrawer.setAttribute('aria-hidden', 'true');
  new MutationObserver(onBodyClassChange).observe(body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', function (e) {
    if (!cartDrawer || !cartIsOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      var closeBtn = cartDrawer.querySelector('.sidecart__toggle');
      if (closeBtn) closeBtn.click();
      return;
    }
    if (e.key === 'Tab') {
      var items = focusables(cartDrawer);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!cartDrawer.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* 6. Re-apply fixes when apps or AJAX re-render parts of the page. */
  var pending = false;
  function refresh() {
    pending = false;
    hideDuplicateImageLinks();
    hideSliderClones();
  }
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(refresh, 300);
  }).observe(body, { childList: true, subtree: true });

  function init() {
    refresh();
    syncAllAccordions();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
